<template>
    <v-container>
        <v-label>{{$t('mobile_app.create')}}</v-label>
        <v-form ref="form"
                v-model="isFormValid">
            <v-container>
                <v-row>
                    <v-text-field outlined
                                  :label="$t('mobile_app.name')"
                                  :placeholder="$t('mobile_app.name')"
                                  v-model="mobileApp.name"
                                  :rules="requiredRules"></v-text-field>
                </v-row>
                <v-row>
                    <v-text-field outlined
                                  :label="$t('mobile_app.app_id')"
                                  :placeholder="$t('mobile_app.app_id')"
                                  v-model="mobileApp.app_id"
                                  :rules="requiredRules"></v-text-field>
                </v-row>
                <v-row>
                    <v-text-field outlined
                                  :label="$t('mobile_app.app_type')"
                                  :placeholder="$t('mobile_app.app_type')"
                                  v-model="mobileApp.app_type"
                                  type="number"
                                  :rules="requiredRules"></v-text-field>
                </v-row>
                <v-row>
                    <v-select outlined
                              clearable
                              :label="$t('mobile_app.company')"
                              :placeholder="$t('mobile_app.company')"
                              :items="companyOptions"
                              v-model="mobileApp.companyId"
                              :rules="requiredRules"></v-select>
                </v-row>
                <v-data-table :headers="eventHeaders"
                              :items="events"
                              show-select
                              v-model="selectedEvents">
                    <template v-slot:item.start_date="{value}">
                        {{DateTime.fromISO(value).toFormat('yyyy-MM-dd')}}
                    </template>
                    <template v-slot:item.end_date="{value}">
                        {{DateTime.fromISO(value).toFormat('yyyy-MM-dd')}}
                    </template>
                    <template v-slot:item.actions="{item}">
                        <v-btn color="primary"
                               @click="$router.push({name: 'event-edit', params: {eventId:item.id}})">
                            {{$t('edit')}}
                            <v-icon right>mdi-account-edit</v-icon>
                        </v-btn>
                    </template>
                </v-data-table>
                <v-row>
                    <v-col>
                        <v-btn color="primary" @click="saveMobileApp" :disabled="!isFormValid">
                            {{$t('mobile_app.create')}}
                        </v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </v-form>
    </v-container>
</template>

<script>
    import {computed, ref, watch} from '@vue/composition-api'
    import {useFind} from "feathers-vuex";
    import {DateTime} from "luxon";

    export default {
        name: 'MobileAppAdd',
        setup(props, {root}) {
            const {MobileApp, Company, Event, AppEvent} = root.$FeathersVuex.api;
            const mobileApp = new MobileApp({
                companyId: root.$store.state.prefilledCompanyId
            });

            function IsJsonString(str) {
                try {
                    JSON.parse(str);
                } catch (e) {
                    return false;
                }
                return true;
            }

            const metadataRules = ref([
                value => (value.length === 0 || !!IsJsonString(value)) || 'Invalid JSON String',
            ]);

            const companyParams = computed(() => {
                return {
                    query: {
                        $sort: {
                            name: 1,
                        }
                    }
                }
            });
            const companyData = useFind({model: Company, params: companyParams});
            const companyOptions = computed(() => {
                return companyData.items.value.map(c => {
                    return {text: c.name, value: c.id}
                });
            });
            const requiredRules = ref([
                value => !!value || 'Required',
            ]);

            // Events
            const eventParams = computed(() => {
                return {
                    query: {
                        companyId: mobileApp.companyId,
                        $sort: {
                            createdAt: -1,
                        }
                    }
                }
            });
            const eventData = useFind({model: Event, params: eventParams});
            const eventHeaders = ref([
                {text: root.$t('event.name'), value: 'name'},
                {text: root.$t('event.start_date'), value: 'start_date'},
                {text: root.$t('event.end_date'), value: 'end_date'},
            ]);

            const selectedEvents = ref([]);
            watch(() => mobileApp.companyId, (newVal) => {
                selectedEvents.value = [];
            });

            const isFormValid = ref(false);
            const showPassword = ref(false);

            const saveMobileApp = () => {
                mobileApp.save().then(() => {
                    // Create AppEvent
                    Promise.allSettled(selectedEvents.value.map((e) => {
                        return new AppEvent({mobileAppId: mobileApp.id, eventId: e.id}).save();
                    })).then((x) => {
                        console.log(x);
                        root.$router.replace({name: 'mobile-app-list'});
                    });
                }, root.$handleFeatherError.bind(root));
            };

            return {
                mobileApp,
                metadataRules,
                companyOptions,

                events: eventData.items,
                eventHeaders,
                selectedEvents,

                requiredRules,
                isFormValid,
                showPassword,
                saveMobileApp,

                DateTime,
            }
        },
    }
</script>